module.exports = "https://cdn2-fs.clearscore.com/flux/images/cf0789d629e9c41fea26ae8d518754f4.jpg";